/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

const qtyInput = document.querySelector(".sticky-quantity-selector  .qty-input");
const wrpqtyInput = document.querySelector("quantity-counter.quantity-selector  .quantity__input");
const qtyPlus = document.querySelector(".sticky-quantity-selector .plus");
const qtyMinus = document.querySelector(".sticky-quantity-selector .minus");
  if(qtyPlus){
    qtyPlus.addEventListener("click", function () {
      qtyInput.value = parseInt(qtyInput.value) + 1;
      wrpqtyInput.value = parseInt(wrpqtyInput.value) + 1;
    });
  }
    if (qtyMinus){
          qtyMinus.addEventListener("click", function () {
          const currentVal = parseInt(qtyInput.value);
          const minVal = parseInt(qtyInput.min);
          if (currentVal > minVal) {
            qtyInput.value = currentVal - 1;
            wrpqtyInput.value = currentVal - 1;
          }
        });  
    }
    



// Added by MS


//   var interval = setInterval(function() {
//     var gs = document.querySelector('grid-slider');
//     if (!gs) return;

//     var slider = gs.querySelector('.ftm-slider[data-grid-slider]');
//     var slides = Array.from(gs.querySelectorAll('[data-grid-item].product-item'));
//     if (!slider || !slides.length) return;
//     if (gs.querySelector('.custom-slider-dots')) return;

//     clearInterval(interval);

//     var sliderWidth = slider.clientWidth;
//     var slideWidth = slides[0].offsetWidth;
//     var visibleCount = Math.round(sliderWidth / slideWidth);
//     var dotCount = slides.length - visibleCount + 1;
//     if (dotCount < 2) return;

//     var dj = document.createElement('div');
//     dj.className = 'custom-slider-dots';

//     for (var d = 0; d < dotCount; d++) {
//       (function(idx) {
//         var dot = document.createElement('button');
//         dot.className = 'custom-slider-dot' + (idx === 0 ? ' is-active' : '');
//         dot.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
//         dot.addEventListener('click', function() {
//           // Last dot scrolls to the very end
//           var isLast = idx === dotCount - 1;
//           var scrollTarget = isLast
//             ? slider.scrollWidth - slider.clientWidth
//             : slides[idx].offsetLeft;
//           slider.scrollTo({ left: scrollTarget, behavior: 'smooth' });
//         });
//         dj.appendChild(dot);
//       })(d);
//     }

//     gs.appendChild(dj);

//     // function updateDots() {
//     //   var dots = dj.querySelectorAll('.custom-slider-dot');
//     //   var activeIdx = 0;
//     //   for (var i = 0; i < slides.length; i++) {
//     //     if (slides[i].classList.contains('is-visible')) {
//     //       activeIdx = i;
//     //       break;
//     //     }
//     //   }
//     //   activeIdx = Math.min(activeIdx, dotCount - 1);
//     //   dots.forEach(function(dot, i) {
//     //     dot.classList.toggle('is-active', i === activeIdx);
//     //   });
//     // }

//     // JG code start
//       function updateDots() {
//         var dots = dj.querySelectorAll('.custom-slider-dot');
//         var scrollLeft = slider.scrollLeft;

//         var activeIdx = 0;
//         var minDiff = Infinity;

//         slides.forEach(function(slide, i) {
//           var diff = Math.abs(slide.offsetLeft - scrollLeft);

//           if (diff < minDiff) {
//             minDiff = diff;
//             activeIdx = i;
//           }
//         });

//         activeIdx = Math.min(activeIdx, dotCount - 1);

//         dots.forEach(function(dot, i) {
//           dot.classList.toggle('is-active', i === activeIdx);
//         });
//       }
//       slider.addEventListener('scroll', function() {
//         updateDots();
//       });

//       // JG code end

//     var mo = new MutationObserver(updateDots);
//     slides.forEach(function(slide) {
//       mo.observe(slide, { attributes: true, attributeFilter: ['class'] });
//     });

//     updateDots();
//   }, 300);
// // Added by MS End 

//   // ^^ Keep your scripts inside this IIFE function call to 
//   // avoid leaking your variables into the global scope.
// })();



// ---- new js=-==


// Added by MS
  var interval = setInterval(function() {
    var gs = document.querySelector('grid-slider');
    if (!gs) return;

    var slider = gs.querySelector('.ftm-slider[data-grid-slider]');
    var slides = Array.from(gs.querySelectorAll('[data-grid-item].product-item'));
    if (!slider || !slides.length) return;
    if (document.querySelector('.ftm-feature-coll .slider__arrows')) return;

    clearInterval(interval);

    var sliderWidth = slider.clientWidth;
    var slideWidth = slides[0].offsetWidth;
    var visibleCount = Math.round(sliderWidth / slideWidth);
    var dotCount = slides.length - visibleCount + 1;
    if (dotCount < 2) return;

    // --- Inject arrows into .grid__heading-holder ---
    var headingHolder = document.querySelector('.ftm-feature-coll .grid__heading-holder');
    var arrowContainer = document.createElement('div');
    arrowContainer.className = 'slider__arrows';
    arrowContainer.style.cssText = 'display:flex !important; visibility:visible !important; opacity:1 !important;';

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'slider__button slider__button--prev';
    prevBtn.setAttribute('data-button-arrow', '');
    prevBtn.setAttribute('data-button-prev', '');
    prevBtn.textContent = 'Previous';
    prevBtn.disabled = true;

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'slider__button slider__button--next';
    nextBtn.setAttribute('data-button-arrow', '');
    nextBtn.setAttribute('data-button-next', '');
    nextBtn.textContent = 'Next';

    arrowContainer.appendChild(prevBtn);
    arrowContainer.appendChild(nextBtn);

    if (headingHolder) {
      headingHolder.appendChild(arrowContainer);
    } else {
      // fallback: inject above slider if no heading holder
      gs.insertBefore(arrowContainer, gs.firstChild);
    }
    // --- End arrows ---

    // --- Dots ---
    var dj = document.createElement('div');
    dj.className = 'custom-slider-dots';

    for (var d = 0; d < dotCount; d++) {
      (function(idx) {
        var dot = document.createElement('button');
        dot.className = 'custom-slider-dot' + (idx === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
        dot.addEventListener('click', function() {
          scrollToIdx(idx);
        });
        dj.appendChild(dot);
      })(d);
    }

    gs.appendChild(dj);
    // --- End dots ---

    function scrollToIdx(idx) {
      var isLast = idx === dotCount - 1;
      var scrollTarget = isLast
        ? slider.scrollWidth - slider.clientWidth
        : slides[idx].offsetLeft;
      slider.scrollTo({ left: scrollTarget, behavior: 'smooth' });
    }

    function getCurrentIdx() {
      var dots = dj.querySelectorAll('.custom-slider-dot');
      for (var i = 0; i < dots.length; i++) {
        if (dots[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    prevBtn.addEventListener('click', function() {
      var idx = getCurrentIdx();
      if (idx > 0) scrollToIdx(idx - 1);
    });

    nextBtn.addEventListener('click', function() {
      var idx = getCurrentIdx();
      if (idx < dotCount - 1) scrollToIdx(idx + 1);
    });

    function updateDots() {
      var dots = dj.querySelectorAll('.custom-slider-dot');
      var scrollLeft = slider.scrollLeft;

      var activeIdx = 0;
      var minDiff = Infinity;

      slides.forEach(function(slide, i) {
        var diff = Math.abs(slide.offsetLeft - scrollLeft);
        if (diff < minDiff) {
          minDiff = diff;
          activeIdx = i;
        }
      });

      activeIdx = Math.min(activeIdx, dotCount - 1);

      dots.forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === activeIdx);
      });

      prevBtn.disabled = activeIdx === 0;
      nextBtn.disabled = activeIdx === dotCount - 1;
    }

    slider.addEventListener('scroll', function() {
      updateDots();
    });

    var mo = new MutationObserver(updateDots);
    slides.forEach(function(slide) {
      mo.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });

    updateDots();
  }, 300);

  })();
// Added by MS End